<template>
  <v-content class="noPadding">
    <section id="hero">
      <v-row no-gutters>
        <v-img
          class="ml-n12 mt-n5"
          :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
          src="@/assets/members_picture.jpg"
          gradient="to top, rgba(0,0,0,.35), rgba(0,0,0,.85)"
          :min-width="'calc(100vw)'"
        >
          <v-theme-provider dark>
            <v-container fill-height>
              <v-row align="center" class="white--text mx-auto" justify="center">
                <v-col class="white--text text-center lower" cols="12" tag="h1">
                  <span
                    class="font-weight-light"
                    :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-1']"
                  >WELCOME TO</span>
                  <!--
                    <span
                    class="font-weight-light"
                    :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
                  >WELCOME TO</span>
                  -->
                  <br />

                  <span
                    :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-3']"
                    class="font-weight-black"
                  >ZHANG LAB</span>
                  <!-- <span
                    :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']"
                    class="font-weight-black"
                  >ZHANG LAB</span> -->
                </v-col>

                <!-- <v-btn fab outlined @click="$vuetify.goTo('#about-me')">
                  <v-icon>mdi-chevron-double-down</v-icon>
                </v-btn> -->
              </v-row>
            </v-container>
          </v-theme-provider>
        </v-img>
      </v-row>
    </section>

    <news/>
  </v-content>
</template>

<script>
import News from "./News";

export default {
  name: "HomePage",
  components: {
    News
  }
};
</script>

<style scoped>
.noPadding {
  padding: 0em !important;
}

.lower{
  padding-top: 10rem;
}

.margin {
  margin-top: 2rem;
  margin-bottom: 0;
}

.center {
  align-self: center;
  align-content: center;
  text-align: center !important;
}

.divMargin {
  margin-bottom: 1rem !important;
  margin-top: 1rem !important;
}

.text {
  text-align: justify;
  padding-right: 10px;
  padding-left: 10px;
  word-break: break-word;
}

.awards {
  font-size: 2rem;
  margin-bottom: 0.5rem !important;
}

.vertical {
  vertical-align: top;
}
</style>